import { useEffect, useState } from "react";

function diff(endIso) {
  const end = new Date(endIso).getTime();
  const now = Date.now();
  const ms = Math.max(0, end - now);
  const total = Math.floor(ms / 1000);
  const d = Math.floor(total / 86400);
  const h = Math.floor((total % 86400) / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return { d, h, m, s, total };
}

export default function CountdownTimer({ endTime, size = "md", onExpire }) {
  const [t, setT] = useState(() => diff(endTime));

  useEffect(() => {
    setT(diff(endTime));
    const id = setInterval(() => {
      const n = diff(endTime);
      setT(n);
      if (n.total === 0 && onExpire) onExpire();
    }, 1000);
    return () => clearInterval(id);
  }, [endTime, onExpire]);

  const critical = t.total <= 10 && t.total > 0;
  const expired = t.total === 0;

  const pad = (n) => String(n).padStart(2, "0");
  const cls = size === "lg"
    ? "font-mono-tight text-3xl sm:text-4xl font-medium tracking-tight"
    : size === "sm"
    ? "font-mono-tight text-xs font-medium"
    : "font-mono-tight text-lg font-medium tracking-tight";

  if (expired) {
    return <span className={`${cls} text-slate-400`} data-testid="auction-timer">Sona erdi</span>;
  }

  return (
    <span className={`${cls} ${critical ? "text-[#B54037]" : "text-slate-900"} inline-flex items-baseline gap-1`} data-testid="auction-timer">
      {t.d > 0 && <><span>{t.d}g</span><span className="text-slate-300">·</span></>}
      <span>{pad(t.h)}</span>
      <span className="text-slate-300">:</span>
      <span>{pad(t.m)}</span>
      <span className="text-slate-300">:</span>
      <span className={critical ? "seconds-critical" : ""}>{pad(t.s)}</span>
    </span>
  );
}
